import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=24fb6124&"
import script from "./Theme.vue?vue&type=script&lang=js&"
export * from "./Theme.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports